import fr from 'facet-rest';
import DateOrYearPickerWhatIf from 'Components/ComponentLibrary/Molecules/dateOrYearPicker/whatIf';
import WizardStepOverrides from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export default fr.metaOverride({ base: WizardStepOverrides })
  .nameOverride('primaryClientRetirementDate', {
    _component: () => DateOrYearPickerWhatIf,
    _customProps: {
      startDateField: 'primaryClientBirthDate',
      isAge: true,
    },
  }, overrideReadOnly)
  .nameOverride('secondaryClientRetirementDate', {
    _component: () => DateOrYearPickerWhatIf,
    _customProps: {
      startDateField: 'secondaryClientBirthDate',
      isAge: true,
    },
  }, overrideReadOnly);
